import React, {useEffect, useState} from 'react';
import {Button, Form, message, Modal, Radio, Select} from 'antd';
import {OrderType} from "../graphql/types/OrderType";
import ImageUploader from './ImageUploader';
import { t } from 'i18n';

interface SetReturnStatusModalProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: (values: SetReturnStatusData) => void;
    loading?: boolean;
    parcels: OrderType[];
}

export interface SetReturnStatusData {
    orderIds: string[];
    returnedImageS3KeysJson: string[];
}

const SetReturnStatusModal: React.FC<SetReturnStatusModalProps> = ({
    visible,
    onClose,
    onConfirm,
    loading = false,
    parcels
}) => {
    const [form] = Form.useForm<SetReturnStatusData>();
    const [returnStatus, setReturnStatus] = useState<string>('returned');
    const [images, setImages] = useState<string[]>([]);

    useEffect(() => {
        form.resetFields();
        setImages([]);
        setReturnStatus('returned');
    }, [visible]);

    const handleSubmit = () => {
        if (images.length < 1){
            message.warning(t('components.modal.uploadAtLeastOneImage'));
            return;
        }
        onConfirm({
            orderIds: parcels.map(parcel => parcel.id),
            returnedImageS3KeysJson: images
        });
        onClose();
    };

    const handleStatusChange = (e: any) => {
        setReturnStatus(e.target.value);
    };

    return (
        <Modal
            title={
                <div className="flex items-center">
                    <div className="w-1 h-6 bg-violet-600 mr-2"></div>
                    <span>{t('components.modal.setReturnStatus')}</span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="submit" type="primary" onClick={handleSubmit} loading={loading} className="bg-violet-600">
                    {t('components.button.set')}
                </Button>,
                <Button key="cancel" onClick={onClose} disabled={loading} className="bg-gray-100 text-gray-600">
                    {t('components.button.cancel')}
                </Button>,
            ]}
            width={500}
            maskClosable={!loading}
            closable={!loading}
        >
            <Form
                form={form}
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                disabled={loading}
            >
                <Form.Item name="exceptionReasonCode">
                    <p className="text-gray-500 mb-4">{t('components.modal.setReturnStatusForParcels', { count: parcels.length })}</p>
                    <Radio.Group
                        value={returnStatus}
                        onChange={handleStatusChange}
                        className="w-full"
                    >
                        <div className="flex flex-col gap-3">
                            <Radio value="returned">{t('components.modal.returned')}</Radio>
                        </div>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name="photos">
                    <p className="text-gray-500">{t('components.modal.photo')}</p>
                    <ImageUploader
                        value={images}
                        onChange={setImages}
                        maxCount={6}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SetReturnStatusModal;